import type { MaterialResourceFailure } from '~/client/src/shared/resources/domain/materialResourceTypeDefinition'
import type { ResourceResult } from '~/client/src/shared/resources/domain/resourceResult'

/** Translates a typed Material failure at React's rejected-promise seam. */
export function requireMaterialResourceSuccess<T>(
  result: ResourceResult<T, MaterialResourceFailure>,
): T {
  if (result._tag === 'Ok') return result.value
  if (
    result.error._tag === 'ProjectResourceOperationFailure' &&
    result.error.cause instanceof Error
  ) {
    throw result.error.cause
  }
  throw new Error(
    result.error._tag === 'MissingMaterialResourceRecord'
      ? `Cannot save missing Material: ${result.error.recordId}`
      : result.error._tag === 'MissingMaterialResourceId'
        ? 'Material response did not contain an id'
        : `Material operation failed: ${result.error.operation}`,
  )
}
